import React from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { SimflexityPayCompany } from "web-apps/company/pages/payments/simflexityPay/simflexityPay";
import { SubscriptionTerms } from "./subscriptionTerms.component";
import {
  SubscriptionCard,
  SubscriptionCardTitle,
  SubscriptionPageLayout,
  SubscriptionValue,
} from "./companySubscription.styled";
import { SettingsV2PageTitle } from "../companySettingsV2.styled";
import { getSubscriptionDisplayName } from "web-apps/company/utils/subscription.logic";

export const CompanySubscription: React.FC = () => {
  const { t } = useTranslation();
  const [companyState] = useCompanyStore();
  const membershipDisplayName = getSubscriptionDisplayName(
    companyState.subscription.info?.membershipDisplayName ?? "",
  );

  return (
    <SubscriptionPageLayout>
      <SettingsV2PageTitle>
        {t("ProfileCompany.Subscription")}
      </SettingsV2PageTitle>

      <SubscriptionCard>
        <SubscriptionCardTitle>
          {t("ProfileCompany.Subscription")}
        </SubscriptionCardTitle>
        <SubscriptionValue>{t(membershipDisplayName)}</SubscriptionValue>
      </SubscriptionCard>

      <SubscriptionCard>
        <SubscriptionCardTitle>
          {t("CompanyUsers.Payments")}
        </SubscriptionCardTitle>
        {companyState.company && (
          <SimflexityPayCompany
            companyId={companyState.company.id.toString()}
            variant="settings"
            showTitle={false}
          />
        )}
      </SubscriptionCard>

      <SubscriptionCard>
        <SubscriptionTerms />
      </SubscriptionCard>
    </SubscriptionPageLayout>
  );
};
